var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "area-report-container" },
    [
      _c("div", { staticClass: "report-actions pa-4" }, [
        _c("h2", { staticClass: "title mb-4" }, [
          _vm._v("Junction Box Report"),
        ]),
        _c(
          "div",
          { staticClass: "d-flex", staticStyle: { gap: "6px" } },
          [
            _c(
              "v-btn",
              {
                attrs: {
                  color: "primary",
                  loading: _vm.isLoading,
                  disabled: _vm.isLoading,
                  small: "",
                },
                on: { click: _vm.loadAndRenderReport },
              },
              [
                _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-eye")]),
                _vm._v(" View "),
              ],
              1
            ),
            _c(
              "v-btn",
              {
                attrs: {
                  color: "secondary",
                  disabled: !_vm.hasReport || _vm.isLoading,
                  small: "",
                },
                on: { click: _vm.downloadReport },
              },
              [
                _c("v-icon", { attrs: { left: "" } }, [_vm._v("mdi-download")]),
                _vm._v(" Download "),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("v-divider"),
      _c("div", { staticClass: "report-content pa-4" }, [
        !_vm.hasReport && !_vm.isLoading && !_vm.errorMessage
          ? _c("div", { staticClass: "text-center text--secondary" }, [
              _c("p", [
                _vm._v(
                  'Report not available. Please click on "View" to generate a new report.'
                ),
              ]),
            ])
          : _vm._e(),
        _vm.isLoading
          ? _c(
              "div",
              { staticClass: "text-center" },
              [
                _c("v-progress-circular", {
                  attrs: { indeterminate: "", color: "primary" },
                }),
                _c("p", { staticClass: "mt-4" }, [
                  _vm._v("Loading report preview..."),
                ]),
              ],
              1
            )
          : _vm._e(),
        _vm.errorMessage
          ? _c("div", { staticClass: "text-center red--text text--darken-2" }, [
              _c("p", [_vm._v(_vm._s(_vm.errorMessage))]),
            ])
          : _vm._e(),
        _c("div", {
          ref: "reportContainer",
          staticClass: "docx-preview-wrapper",
        }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }